"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M17.693 20.239H6.308a2.55 2.55 0 0 1-2.547-2.547V6.307A2.55 2.55 0 0 1 6.308 3.76h11.385a2.55 2.55 0 0 1 2.547 2.547v11.385a2.55 2.55 0 0 1-2.547 2.547M6.307 4.789a1.52 1.52 0 0 0-1.519 1.519v11.385a1.52 1.52 0 0 0 1.519 1.519h11.385a1.52 1.52 0 0 0 1.519-1.519V6.308a1.52 1.52 0 0 0-1.519-1.519z"
}), 'CheckboxEmpty');
